
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Overlay extends Vue {
  @Prop() color!: string;
  @Prop() size!: number;

  overlay = false;

  show(): void {
    this.overlay = true;
  }

  hide(): void {
    this.overlay = false;
  }
}
